import React, { useMemo } from 'react';
import Link from 'next/link';
import { IMenuItem } from '~/src/api/content/menu';
import * as ST from '~/src/components/Header/styled';
import { ICurrentCity } from '~/src/store/reducers/city';
import geo from '~/static/images/header/geo_new.svg';

interface IProps {
  menuItems: IMenuItem[];
  isTablet: boolean;
  isDrop: boolean;
  colorText?: string;
  analytics: string;
  isBottom?: boolean;
  onClick: (item: string, menuType?: string) => void;
  onHover: (item: string, menuType?: string) => void;
  clickHandler?: () => void;
  openCitySelect: () => void;
  city: ICurrentCity;
  isDesktop?: boolean;
}

const TABLET_TOP_MENU_COUNT = 2;
const TOPMENU_ITEMS_COUNT = 3;
const mnItemsTopLeft = [
  {
    add_desc: '',
    available: 1,
    button_link: '',
    button_text: '',
    children: [],
    css_icon: '',
    desc: '',
    id: 1441,
    image: null,
    link: 'https://tcenter.ru/',
    name: 'На основной сайт',
    parent: 1,
    parent_id: null,
    parent_ids: [],
    promo_description: '',
    promo_link: '',
    promo_title: '',
    promoted: 0,
    title: 'На основной сайт',
    view: 0,
    weight: 1,
  },
  {
    add_desc: '',
    available: 1,
    button_link: '',
    button_text: '',
    children: [],
    css_icon: '',
    desc: '',
    id: 1451,
    image: null,
    link: 'https://movix.ru/',
    name: 'Онлайн-кинотеатр Movix',
    parent: 1,
    parent_id: null,
    parent_ids: [],
    promo_description: '',
    promo_link: '',
    promo_title: '',
    promoted: 0,
    title: 'Онлайн-кинотеатр Movix',
    view: 0,
    weight: 2,
  },
];
const TopMenu = ({
  isTablet,
  onClick,
  onHover,
  isDrop,
  isBottom,
  colorText,
  clickHandler,
  analytics,
  city,
  isDesktop,
}: IProps): JSX.Element => {
  const preparedTopMenu = useMemo(() => {
    const TopMenuItems = isTablet ? TABLET_TOP_MENU_COUNT : TOPMENU_ITEMS_COUNT;
    if (mnItemsTopLeft.length <= TopMenuItems) {
      return { visible: mnItemsTopLeft };
    }

    const visible = mnItemsTopLeft.slice(0, TopMenuItems);
    const collapsed = mnItemsTopLeft.slice(TopMenuItems);

    return { visible, collapsed };
  }, [isTablet, mnItemsTopLeft]);

  return (
    <div>
      <ST.ImgWrapper>
        <img src={geo} alt='' />
      </ST.ImgWrapper>
      <ST.CitySelect data-test='city-select-btn'>
        {city ? city.name : null}
      </ST.CitySelect>
      {isDesktop
        ? preparedTopMenu?.visible.map((item) => (
            <ST.TopMenuItem
              key={item.id}
              isDrop={isDrop}
              isBottom={isBottom}
              isUnderMenuText={Boolean(colorText)}
              onClick={clickHandler}
              data-test='top-menu-item'
              className={'element'}
            >
              <Link href={item.link} prefetch={false} passHref>
                <ST.LinkItemDrop
                  target='_blank'
                  isDrop={isDrop}
                  onClick={() => onClick(item.title, analytics)}
                  onMouseEnter={() => onHover(item.title, analytics)}
                  color={colorText}
                >
                  {item.title}
                </ST.LinkItemDrop>
              </Link>
            </ST.TopMenuItem>
          ))
        : null}
      {preparedTopMenu?.collapsed && preparedTopMenu.collapsed.length > 0 && (
        <>
          {preparedTopMenu.collapsed.map((item) => (
            <ST.TopMenuItem
              data-test={'top-menu-collapsed'}
              key={item.id}
              isDrop={isDrop}
              isBottom={isBottom}
            >
              <Link key={item.id} href={item.link} prefetch={false} passHref>
                <ST.LinkItemDrop
                  isDrop={isDrop}
                  onClick={() => onClick(item.title, analytics)}
                  onMouseEnter={() => onHover(item.title, analytics)}
                >
                  {item.title}
                </ST.LinkItemDrop>
              </Link>
            </ST.TopMenuItem>
          ))}
        </>
      )}
    </div>
  );
};

export default TopMenu;
